document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    document.querySelectorAll('.tab').forEach(function (tab) {

        tab.addEventListener('click', function () {

            var tabClass = tab.dataset.id;

            Array.from(tab.parentElement.children).forEach(function (sibling) {
                sibling.classList.toggle('active', sibling === tab);
            });
            document.querySelectorAll('.tab-content').forEach(function (content, i) {
                content.classList.remove('active');
                content.classList.add('inactive', 'tab-content-' + (i + 1));
            });

            document.querySelectorAll('.tab-content-' + tabClass).forEach(function (content) {
                content.classList.remove('inactive');
                content.classList.add('active');
            });

        });

    });

});

//# sourceMappingURL=tabs.js.map
